import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReportOnboardingFlow from "./ReportOnboardingFlow";

interface ReportOnboardingFlowDialogProps {
  open: boolean;
  onClose: () => void;
}

const ReportOnboardingFlowDialog: React.FC<ReportOnboardingFlowDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          pb: 1,
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "action.hover",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3, pt: 2 }}>
        <ReportOnboardingFlow />
      </DialogContent>
    </Dialog>
  );
};

export default ReportOnboardingFlowDialog;












